export const LINKEDIN_URL = "https://www.linkedin.com/in/Devang-agarwal0435";
export const LINKEDIN_HANDLE = "linkedin.com/in/Devang-agarwal0435";
export const INSTAGRAM_URL = "https://www.instagram.com/_beingdevang";
export const INSTAGRAM_HANDLE = "@_beingdevang";
export const EMAIL = "devangagarwal@gmail.com";
export const RESUME_URL = "https://fwsncrcdlzbpkgwssgqn.supabase.co/storage/v1/object/public/resume/resume.pdf";export const TAGLINE =
    "Building a career in marketing, tech and business — with a long-term vision of creating something of my own.";

export const NAV_ITEMS = [
    { id: "home", label: "Home", path: "/" },
    { id: "about", label: "About", path: "/about" },
    { id: "projects", label: "Projects", path: "/projects" },
    { id: "experience", label: "Experience", path: "/experience" },
    { id: "skills", label: "Skills", path: "/skills" },
    { id: "certifications", label: "Certifications", path: "/certifications" },
    { id: "contact", label: "Contact", path: "/contact" },
];

export const HOME_BIO =
    "I'm a BBA graduate (Guru Gobind Singh Indraprastha University, 2026) with a passion for marketing, technology and creating real-world impact. I love building things — from digital products to business ideas.";

export const ABOUT_P1 =
    "I'm Devang, a 22-year-old from Kaimganj (Farrukhabad), currently based in Delhi NCR. I'm passionate about marketing, brand building and technology, and I'm always exploring ways to turn ideas into valuable products and businesses.";

export const ABOUT_P2 =
    "Outside of work, you'll find me cooking, brewing coffee, tinkering with tech, or getting lost in story-driven PC games. I believe in continuous learning, meaningful experiences and building a life of freedom — both financial and creative.";

export const HERO_IMAGES = [
    "https://images.unsplash.com/photo-1601907482852-9b02d7a8716f?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1668630491137-6f39aec7ea33?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1512284125381-bdb1f3a77338?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1752391873033-839ff56ff6c6?auto=format&fit=crop&w=1600&q=80",
];

export const ABOUT_IMAGE =
    "https://images.unsplash.com/photo-1668630491137-6f39aec7ea33?auto=format&fit=crop&w=1200&q=80";

export const goals = [
    "Build a strong career in marketing (brand management / FMCG / product).",
    "Gain financial independence.",
    "Start a manufacturing business (long-term).",
    "Help make Kaimganj a business center and create opportunities there.",
];

export const projects = [
    {
        slug: "krispykitchennirala",
        title: "KrispyKitchenNirala",
        subtitle: "Live Restaurant Ordering Website",
        tags: ["Web Development", "UI/UX", "Business"],
        category: "Web Development",
        image:
            "https://images.unsplash.com/photo-1512058454905-6b841e7ad132?auto=format&fit=crop&w=1200&q=80",
        link: "",
        show_link: false,
    },
    {
        slug: "expense-tracker-app",
        title: "Expense Tracker App",
        subtitle: "Personal Finance App (Android)",
        tags: ["Android", "Kotlin", "Personal"],
        category: "Android",
        image:
            "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?auto=format&fit=crop&w=1200&q=80",
        link: "",
        show_link: false,
    },
    {
        slug: "social-media-marketing-impact",
        title: "Social Media Marketing Impact",
        subtitle: "BBA Major Project (Zepto Users)",
        tags: ["Research", "Analysis", "Marketing"],
        category: "Research",
        image:
            "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
        link: "",
        show_link: false,
    },
    {
        slug: "careeros-concept",
        title: "CareerOS (Concept)",
        subtitle: "Personal Operating System Website",
        tags: ["Web Design", "Automation", "Productivity"],
        category: "Web Design",
        image:
            "https://images.unsplash.com/photo-1754039984985-ef607d80113a?auto=format&fit=crop&w=1200&q=80",
        link: "",
        show_link: false,
    },
];

export const experience = {
    role: "Sales Executive Intern",
    org: "DK Realty and Interiors",
    location: "Greater Noida",
    period: "May – Jul 2024 (3 months)",
    bullets: [
        "Made 6000+ calls (200+/day average) from lead data",
        "Handled WhatsApp follow-ups and client tracking",
        "Maintained Excel sheets and updated lead status",
        "Learned about real estate sales and customer handling",
    ],
};

export const skills = [
    {
        label: "Marketing & Business",
        items: ["Branding", "Consumer Behaviour", "Content Creation", "Lead Generation"],
    },
    {
        label: "Tech & Tools",
        items: ["Excel", "PowerPoint", "Canva", "SQL", "ChatGPT", "Lovable"],
    },
    {
        label: "Other",
        items: ["Communication", "Problem Solving", "Adaptability"],
    },
];

export const DEFAULT_CONTENT = {
    hero_bio: HOME_BIO,
    about_p1: ABOUT_P1,
    about_p2: ABOUT_P2,
    goals,
    skills,
    experiences: [experience],
    certifications: [],
    contact: {
        email: EMAIL,
        linkedin_url: LINKEDIN_URL,
        linkedin_handle: LINKEDIN_HANDLE,
        instagram_url: INSTAGRAM_URL,
        instagram_handle: INSTAGRAM_HANDLE,
        location: "Delhi NCR, India",
    },
    projects,
};
